// =====================================================================
// src/lib/icones.js — qual ícone cada módulo usa no menu
//
// Os ícones são os do app do Monteiro (sprite SVG outline 24x24, stroke
// 1.5, currentColor), copiados para index.html. Este mapa é puro para o
// teste garantir que todo módulo do catálogo tem ícone — módulo sem ícone
// aparece no menu com o genérico, nunca sem nada.
// =====================================================================
const MAPA = Object.freeze({
  usuarios:      'ic-usuarios',
  configuracoes: 'ic-settings',
  governanca:    'ic-broom',
  checkin:       'ic-checkin',
  precheckin:    'ic-clipboard',
  manutencao:    'ic-wrench',
  garagem:       'ic-garagem',
  visitas:       'ic-door',        // 0045: fornecedor bate à porta; a guarita abre
  escalas:       'ic-calendar-plus',
  seguranca:     'ic-shield',
  auditoria:     'ic-relatorios',
  fnrh:          'ic-note',
  painel:        'ic-dashboard',
  reservas:      'ic-reservas',
  hospedes:      'ic-hospedes',
  frigobar:      'ic-loja-frigobar',
  financeiro:    'ic-financeiro',
  importacao:    'ic-import',       // 0051: o Importar do MdM (2724)
  pessoal:       'ic-funcionarios', // 0054: a página Funcionários do MdM (12372)
  flats:         'ic-flats',        // 0101: a página Flats do MdM (renderFlats, 10485)
  vaga_garagem:  'ic-garagem',       // 0101: a Garagem da imobiliária
});
export const ICONE_GENERICO = 'ic-dashboard';
export function iconeDoModulo(chave) { return MAPA[chave] || ICONE_GENERICO; }
export const MODULOS_COM_ICONE = Object.freeze(Object.keys(MAPA));
